module.exports = __webpack_public_path__ + "static/media/success-verify.37c6455f.svg";